import React, { useEffect, useState } from "react";
import {
  GSForm,
  GSSidePanelPage,
  useFormDataValidation,
} from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "./tournament-reporting-order-edit-customer.scss";
import {
  clearNotifications,
  getOrder,
  saveRegistrationCustomer,
  selectCurrentOrder,
  selectLoading,
  selectNotifications,
} from "../../../reducers/reportingSlice";
import { getRegistrationCustomerEditForm } from "../../../forms/ReportingForm";
import {
  getSaveBannerActions,
  useNotificationBanner,
  useNotificationNavigation,
} from "../../../hooks/notificationHooks";

const TournamentReportingOrderEditCustomer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const match = useMatch("/:tournamentID/reporting/:orderID/edit-order");

  const currentOrder = useSelector(selectCurrentOrder);
  const notifications = useSelector(selectNotifications);
  const loading = useSelector(selectLoading);

  const [customer, setCustomer] = useState(null);
  const [context, isValid, setIsValid] = useFormDataValidation({
    initialValid: false,
    data: customer,
    setData: (update) => setCustomer(update),
  });

  useEffect(() => {
    if (match?.params?.orderID && currentOrder?.id !== match.params.orderID) {
      dispatch(getOrder(match.params.orderID));
    }
    return () => {
      dispatch(clearNotifications());
    };
  }, [dispatch, match?.params?.orderID, currentOrder?.id]);

  useEffect(() => {
    if (currentOrder?.registrationCustomer && !customer) {
      setCustomer({ ...currentOrder.registrationCustomer });
    }
  }, [currentOrder?.registrationCustomer, customer]);

  const save = () => {
    setUnsaved(false);
    setIsValid(false);
    if (customer?.id) {
      dispatch(saveRegistrationCustomer(customer));
    }
  };

  const leftNavigation = () => {
    if (isValid && !bannerNotifications) {
      setUnsaved(true);
      return;
    }
    timeoutAction();
    navigate(-1);
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  useNotificationNavigation(
    "saved",
    notifications,
    `/${match?.params?.tournamentID}/reporting/${match?.params?.orderID}`,
    "Save Customer"
  );

  const isCustomerInvoice =
    currentOrder?.paymentType === "customer_invoice" ||
    !!currentOrder?.invoicePaidAt;

  const getNavigation = () => ({
    title: "Edit Order",
    leftIcon: faChevronLeft,
    leftButtonClick: leftNavigation,
  });

  const getContent = () => (
    <GSForm
      formTitle="Edit Order"
      formSections={getRegistrationCustomerEditForm(context, {
        showCompanyName: isCustomerInvoice,
      })}
    />
  );

  const getDrawerActions = () => [
    {
      name: "Save",
      isDisabled: !isValid,
      action: save,
      type: "black",
    },
    { name: "cancel", action: leftNavigation, type: "grey" },
  ];

  const getDrawer = () => ({
    actions: getDrawerActions(),
  });

  let notificationSettings = {
    notifications,
    saveAction: save,
    bannerActions: getSaveBannerActions(save, leftNavigation),
    timeoutAction,
  };

  const [bannerNotifications, setUnsaved] = useNotificationBanner(
    notificationSettings
  );

  return (
    <tournament-reporting-order-edit-customer>
      <GSSidePanelPage
        loading={loading?.length > 0}
        header={getNavigation()}
        banner={bannerNotifications}
        content={getContent()}
        drawer={getDrawer()}
      />
    </tournament-reporting-order-edit-customer>
  );
};

export default TournamentReportingOrderEditCustomer;
